import * as types from "../types/cancelledOrder.types";
import { getListingService, patchService, patchForceService, ViewImageService } from '../../services/cancelledOrder.service';
import { validationErrors } from "../../utils/Helpers";


export const listAction = (data) => {
  return async (dispatch, getState)  => {
    try {
      dispatch({
        type: types.SET_CANCELLED_ORDER_LOADING,
        payload: true,
      });
      await getListingService(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        if(res.data.code === 200){
          dispatch({
            type: types.SET_CANCELLED_ORDER_DATA,
            payload: res.data.data,
          });
          dispatch({
            type: types.SET_CANCELLED_ORDER_PAGINATION,
            payload: res.data.pagination,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    } finally {
      dispatch({
        type: types.SET_CANCELLED_ORDER_LOADING,
        payload: false,
      });
    }
  };
}

export const filterAction = (data) => {  
  return async (dispatch) => {
    try {
      dispatch({
        type: types.SET_CANCELLED_ORDER_FILTER,
        payload: data,
      });
    } catch {}
  }
}

export const editAction = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: types.SET_CANCELLED_ORDER_LOADING,
        payload: true,
      });
      await patchService(getState().authReducer.token, getState().authReducer.user.id, data)
    } catch (e) {
      validationErrors(e)
    } finally {
      dispatch({
        type: types.SET_CANCELLED_ORDER_LOADING,
        payload: false,
      });
    }
  };
}

export const editActionForce = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: types.SET_CANCELLED_ORDER_LOADING,
        payload: true,
      });
      await patchForceService(getState().authReducer.token, getState().authReducer.user.id, data)
    } catch (e) {
      validationErrors(e)
    } finally {
      dispatch({
        type: types.SET_CANCELLED_ORDER_LOADING,
        payload: false,
      });
    }
  };
}

export const ViewImageAction = (data) => {
  return async (dispatch, getState)  => {
    try {
      const res = await ViewImageService(
        getState().authReducer.token,
        getState().authReducer.user.id,
        data
      );
      return res;   // <----- return here
    } catch (e) {
      validationErrors(e);
    } finally {
    }
  };
}